import { TUTORIAL_EXPLORE_WORDS } from 'constants/tutorials';
import getTutorialCovers from './getTutorialCovers';

export default getTutorialCovers(TUTORIAL_EXPLORE_WORDS);
